<template>
  <div class="liquidationTaskDetail">
    <!-- 基础信息 S -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>基础信息</span>
      </div>
      <el-form  label-width="120px" >
        <!-- 查看 S -->
          <el-row>
            <el-col :span="8">
              <div class="item">
                盘点任务编号：{{taskDetail.yitCode}}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                盘点类型：
                <span v-if="taskDetail.yitType==0">按商品货位盘点</span>
                <span v-if="taskDetail.yitType==1">按商品总数盘点</span>
                <span v-if="taskDetail.yitType==2">按货位盘点</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                状态：{{taskDetail.yitTaskState}}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="item" v-if="taskDetail.yitType == 0 || taskDetail.yitType == 2">
                盘点库区：{{taskDetail.yaName}}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                创建时间：{{taskDetail.yitCreateTime}}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="item">
                接单人：{{taskDetail.yitOrderName }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                完成时间：{{taskDetail.yitCompleteTime }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="item">
                盘点结果：{{taskDetail.yitIsDiff }}
              </div>
            </el-col>
          </el-row>
        <!-- 查看 E -->
     </el-form>
    </el-card>
    <!-- 基础信息 E -->

    <!-- 盘点明细 S -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>盘点明细</span>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane :label="taskDetail.yitType == 2 ? '货位详情' : '商品详情'" name="first">
          <el-table :data="taskDetail.item" style="width: 100%" border>
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column v-if="taskDetail.yitType == 2" prop="ylCode" label="货位编码" align="center"></el-table-column>
            <el-table-column v-else prop="goodName" label="商品名称" align="center"></el-table-column>
            <el-table-column prop="yitaTaskStatus" label="状态" align="center"></el-table-column>
            <el-table-column v-if="taskDetail.yitType != 2" prop="barCode" label="商品条码" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="已盘明细" name="second">
          <el-table :data="taskDetail.detail" style="width: 100%" border>
            <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
            <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop" :label="item.label" align="center"></el-table-column>
            <el-table-column v-if="taskDetail.yitFinishYocType == 1" prop="yidProductionTime" label="生产日期" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.yidFinishOpenStatus == 0">-</span>
                <span v-else>{{scope.row.yidProductionTime || '无'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="yidSysUse" :label="'系统库存\n(正常品)'" align="center" key="yidSysUse">
              <template slot-scope="scope">
                <div>{{scope.row.yidSysUse}}{{ scope.row.minUnit }}</div>
                <div class="goods-tips">({{parseInt(scope.row.yidSysUse / scope.row.box) }}{{ scope.row.maxUnit }}{{ scope.row.yidSysUse % scope.row.box }}{{ scope.row.minUnit }})</div>
              </template>
            </el-table-column>
            <el-table-column prop="yidInventoryUse" :label="'盘点数量\n(正常品)'" align="center" key="yitgInventoryUse">
              <template slot-scope="scope">
                <div>{{scope.row.yidInventoryUse}}{{ scope.row.minUnit }}</div>
                <div class="goods-tips">({{parseInt(scope.row.yidInventoryUse / scope.row.box) }}{{ scope.row.maxUnit }}{{ scope.row.yidInventoryUse % scope.row.box }}{{ scope.row.minUnit }})</div>
              </template>
            </el-table-column>
            <el-table-column prop="yidUseDiff" :label="'库存差异\n(正常品)'" align="center" key="yitgUseDiff">
              <template slot-scope="scope">
                <div :style="changeColor(scope.row.yidUseDiff)">{{scope.row.yidUseDiff}}{{ scope.row.minUnit }}</div>
                <div class="goods-tips">({{parseInt(scope.row.yidUseDiff / scope.row.box) }}{{ scope.row.maxUnit }}{{ scope.row.yidUseDiff % scope.row.box }}{{ scope.row.minUnit }})</div>
              </template>
            </el-table-column>
            <el-table-column prop="yidSysUn" :label="'系统库存\n(破损品)'" align="center" key="yidSysUn">
              <template slot-scope="scope">
                <div>{{scope.row.yidSysUn}}{{ scope.row.minUnit }}</div>
                <div class="goods-tips">({{parseInt(scope.row.yidSysUn / scope.row.box) }}{{ scope.row.maxUnit }}{{ scope.row.yidSysUn % scope.row.box }}{{ scope.row.minUnit }})</div>
              </template>
            </el-table-column>
            <el-table-column prop="yidInventoryUn" :label="'盘点数量\n(破损品)'" align="center" key="yidInventoryUn">
              <template slot-scope="scope">
                <div>{{scope.row.yidInventoryUn}}{{ scope.row.minUnit }}</div>
                <div class="goods-tips">({{parseInt(scope.row.yidInventoryUn / scope.row.box) }}{{ scope.row.maxUnit }}{{ scope.row.yidInventoryUn % scope.row.box }}{{ scope.row.minUnit }})</div>
              </template>
            </el-table-column>
            <el-table-column prop="yidUnDiff" :label="'库存差异\n(破损品)'" align="center" key="yidUnDiff">
              <template slot-scope="scope">
                <div :style="changeColor(scope.row.yidUnDiff)">{{scope.row.yidUnDiff}}{{ scope.row.minUnit }}</div>
                <div class="goods-tips">({{ parseInt(scope.row.yidUnDiff / scope.row.box) }}{{ scope.row.maxUnit }}{{ scope.row.yidUnDiff % scope.row.box }}{{ scope.row.minUnit }})</div>
              </template>
            </el-table-column>
            <el-table-column prop="barCode" label="商品条码" align="center"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <!-- 盘点明细 E -->
  </div>
</template>

<script>
import liquidationManage from '@/store/liquidationManage/index'
import { GETINVENTORYTASKINFO } from '@/store/liquidationManage/types.js'

export default {
  data () {
    return {
      activeName: 'first',
      selectGoodsList: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      let params = {yitCode: this.$route.params.code}
      this.$store.dispatch(GETINVENTORYTASKINFO, params)
    },
    show (type) {
      if (this.taskDetail.yitTaskState === '已取消' || this.taskDetail.yitTaskState === '待接单') {
        return false
      } else if (this.taskDetail.yitQuality !== type) {
        return true
      } else {
        return false
      }
    },
    changeColor (num) {
      if (num > 0) {
        return 'color:red'
      } else if (num < 0) {
        return 'color:#5daf34'
      }
    }
  },
  computed: {
    taskDetail () {
      return liquidationManage.state.liquidationTaskDetail
    },
    taskStatus () {
      return [
        {label: '待接单', value: 0},
        {label: '盘点中', value: 1},
        {label: '盘点完成', value: 2},
        {label: '已取消', value: 3}
      ]
    },
    tableColumn () {
      let list = [
        {label: '商品名称', prop: 'goodsName'}
      ]
      switch (this.taskDetail.yitType) {
        case '0':
          list.push({ label: '货位编码', prop: 'ylCode' })
          break
        case '2':
          list.unshift({ label: '货位编码', prop: 'ylCode' })
          break
      }
      return list
    }

  }
}
</script>

<style scoped>
.liquidationTaskDetail >>> .el-table .cell {
  white-space: pre-line;
}
.el-form {
  padding-left: 30px;
}
.item {
  line-height: 40px;
  font-size: 14px;
}
.goods-tips {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/page/liquidationManage/LiquidationTaskDetail.vue